<template>
  <Layout>
    <template slot="body">
      <Mapa></Mapa>
    </template>
  </Layout>
</template>

<script>
// @ is an alias to /src
import Layout from "@/components/layout/Layout.vue";
import Mapa from "@/components/Mapa.vue";

export default {
  name: "Home",
  components: {
    Layout,
    Mapa,
  },
};
</script>
